import { FormControl, Grid, InputLabel, TextField } from '@mui/material'
import React, { useEffect } from 'react'

export default function Activities({ chapterData, handleChange, setChapterData, onSave }) {

    useEffect(() => {
        if (chapterData) {
            let chapterDetails = {
                ...chapterData,
                contentType: ''
            }
            setChapterData(chapterDetails);
            onSave(chapterDetails);
        }
    }, [])
    return (
        <>
            <Grid item xs={12}>
                <InputLabel style={styles.inputLabel}>Activity</InputLabel>
                <FormControl fullWidth>
                    <TextField
                        name="content"
                        value={chapterData.content}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        rows={6}
                    />
                </FormControl>
            </Grid>
        </>
    )
}

const styles = {
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
}

